<template>
   <div>
      <button id="registerPackBtn" data-bs-target="#confirmMethod" data-bs-toggle="modal" style="display: none" />
      <div class="main-body">
         <div class="container">
            <!-- Button trigger modal-->
            <div class="text-center mt-3 pt-3" style="display: none">
               <button id="registerPackBtn" data-bs-target="#confirmMethod" data-bs-toggle="modal" />
            </div>
            <!-- Modal-->
            <div id="confirmMethod" aria-hidden="true" aria-labelledby="confirmMethod" class="modal fade modal-custom"
               role="dialog" tabindex="-1">
               <div class="modal-dialog" role="document">
                  <div class="modal-custom__content">
                     <div class="modal-custom__header">
                        <span class="modal-custom__action" data-bs-dismiss="modal"><i
                              class="icon-fonts icon-fonts--close"></i></span>
                     </div>
                     <div class="modal-custom__body">
                        <h3 class="modal-custom__title">{{ $t('confirmation.title') }}</h3>
                        <p class="modal-custom__des">{{ $t('mobile.data_packages.title_confirm') }}</p>
                        <div class="payment-type">
                           <ul class="payment-type__list">
                              <!-- U-Money Option -->
                              <template v-if="isErrUmoney || !isPaymentUmoney">
                                 <li class="payment-type__item">
                                    <div class="payment-type__detail">
                                       <span class="payment-type__icon"><img alt="img"
                                             src="@/assets/images/ic-um.svg" /></span>
                                       <div class="payment-type__info">
                                          <h5 class="payment-type__name">{{ $t('mobile.data_packages.u_money') }}</h5>
                                          <p v-if="!isErrUmoney" class="payment-type__des">
                                             {{ $t('mobile.data_packages.balance_not_enough') }}:
                                             <span class="payment-money">{{
                                                uMoney && Object.keys(uMoney).length != 0 && uMoney.eMoneyValue
                                                   ? Number(uMoney.eMoneyValue).toLocaleString('en-US', {
                                                      maximumFractionDigits: 0
                                                   })
                                                   : 0
                                             }}</span>
                                             KIP
                                          </p>
                                          <p v-if="isErrUmoney" class="payment-type__des">
                                             {{ $t('buttons.please_register') }}
                                          </p>
                                       </div>
                                    </div>
                                    <div class="payment-type__btn">
                                       <button v-if="!isErrUmoney" class="button btn-white"
                                          @click="redirectRouter('/mobile/recharge')">
                                          {{ $t('mobile.data_packages.topup') }}
                                       </button>
                                       <button v-if="isErrUmoney" class="button btn-orange"
                                          @click="openDeepLink('mocha://home/umoney')">
                                          {{ $t('buttons.register') }}
                                       </button>
                                    </div>
                                 </li>
                              </template>
                              <template v-else>
                                 <li class="payment-type__item">
                                    <div class="payment-type__detail">
                                       <span class="payment-type__icon"><img alt="img"
                                             src="@/assets/images/ic-um.svg" /></span>
                                       <div class="payment-type__info">
                                          <h5 class="payment-type__name">{{ $t('mobile.data_packages.u_money') }}</h5>
                                          <p v-if="!isErrUmoney" class="payment-type__des">
                                             <span class="payment-money">{{
                                                uMoney && Object.keys(uMoney).length != 0 && uMoney.eMoneyValue
                                                   ? Number(uMoney.eMoneyValue).toLocaleString('en-US', {
                                                      maximumFractionDigits: 0
                                                   })
                                                   : 0
                                             }}</span>
                                             KIP
                                          </p>
                                       </div>
                                    </div>
                                    <div class="payment-type__btn">
                                       <button class="button btn-orange" @click="checkEwalletInfo">
                                          {{ $t('mobile.data_packages.register_by_umoney') }}
                                       </button>
                                    </div>
                                 </li>
                              </template>
                              <!-- End Umoney Option -->
                              <!-- Upoint Option -->
                              <template v-if="registerRoamingLater">
                                 <template v-if="!isPaymentUpoint">
                                    <li class="payment-type__item">
                                       <div class="payment-type__detail">
                                          <span class="payment-type__icon"><img alt="img"
                                                src="@/assets/images/ic-upoint.svg" /></span>
                                          <div class="payment-type__info">
                                             <h5 class="payment-type__name">{{ $t('mobile.data_packages.upoint') }}</h5>
                                             <p class="payment-type__des">
                                                {{ $t('mobile.data_packages.balance_not_enough') }}:
                                                <span class="payment-money">{{
                                                   accountInfo &&
                                                      Object.keys(accountInfo).length != 0 &&
                                                      accountInfo.uPoint
                                                      ? Number(accountInfo.uPoint).toLocaleString('en-US', {
                                                         maximumFractionDigits: 0
                                                      })
                                                      : 0
                                                }}</span>
                                                {{ $t('unit.upoint') }}
                                             </p>
                                          </div>
                                       </div>
                                       <div class="payment-type__btn">
                                          <button class="button btn-white" @click="redirectRouter('/mobile/recharge')">
                                             {{ $t('mobile.data_packages.topup') }}
                                          </button>
                                       </div>
                                    </li>
                                 </template>
                                 <template v-else>
                                    <li class="payment-type__item">
                                       <div class="payment-type__detail">
                                          <span class="payment-type__icon"><img alt="img"
                                                src="@/assets/images/ic-mobile.svg" /></span>
                                          <div class="payment-type__info">
                                             <h5 class="payment-type__name">{{ $t('mobile.data_packages.upoint') }}</h5>
                                             <p v-if="!isErrUmoney" class="payment-type__des">
                                                <span class="payment-money">{{
                                                   accountInfo &&
                                                      Object.keys(accountInfo).length != 0 &&
                                                      accountInfo.uPoint
                                                      ? Number(accountInfo.uPoint).toLocaleString('en-US', {
                                                         maximumFractionDigits: 0
                                                      })
                                                      : 0
                                                }}</span>
                                                {{ $t('unit.upoint') }}
                                             </p>
                                          </div>
                                       </div>
                                       <div class="payment-type__btn">
                                          <button class="button btn-orange"
                                             @click="openConfirmFromOriginalAccountModal(3)">
                                             {{ $t('buttons.register') }}
                                          </button>
                                       </div>
                                    </li>
                                 </template>
                              </template>
                              <!-- End Upoint Option -->
                              <!-- Mobile Balance Option (Basic Balance) -->
                              <template v-if="!isPaymentBalance">
                                 <li class="payment-type__item">
                                    <div class="payment-type__detail">
                                       <span class="payment-type__icon"><img alt="img"
                                             src="@/assets/images/ic-mobile.svg" /></span>
                                       <div class="payment-type__info">
                                          <h5 class="payment-type__name">
                                             {{ $t('mobile.data_packages.mobile_balance') }}
                                          </h5>
                                          <p v-if="subType == 1" class="payment-type__des">
                                             {{ $t('mobile.data_packages.balance_not_enough') }}:
                                             <span class="payment-money">{{
                                                accountInfo &&
                                                   Object.keys(accountInfo).length != 0 &&
                                                   accountInfo.mainAcc
                                                   ? Number(accountInfo.mainAcc).toLocaleString('en-US', {
                                                      maximumFractionDigits: 0
                                                   })
                                                   : 0
                                             }}</span>
                                             KIP
                                          </p>
                                          <p v-if="subType == 2" class="payment-type__des">
                                             {{ $t('mobile.account_information.title_post') }}
                                          </p>
                                       </div>
                                    </div>
                                    <div class="payment-type__btn">
                                       <button class="button btn-white" @click="redirectRouter('/mobile/recharge')">
                                          {{ $t('mobile.data_packages.topup') }}
                                       </button>
                                    </div>
                                 </li>
                              </template>
                              <template v-else>
                                 <li class="payment-type__item">
                                    <div class="payment-type__detail">
                                       <span class="payment-type__icon"><img alt="img"
                                             src="@/assets/images/ic-mobile.svg" /></span>
                                       <div class="payment-type__info">
                                          <h5 class="payment-type__name">
                                             {{ $t('mobile.data_packages.mobile_balance') }}
                                          </h5>
                                          <p v-if="subType == 1" class="payment-type__des">
                                             <span class="payment-money">{{
                                                accountInfo &&
                                                   Object.keys(accountInfo).length != 0 &&
                                                   accountInfo.mainAcc
                                                   ? Number(accountInfo.mainAcc).toLocaleString('en-US', {
                                                      maximumFractionDigits: 0
                                                   })
                                                   : 0
                                             }}</span>
                                             KIP
                                          </p>
                                          <p v-if="subType == 2" class="payment-type__des">
                                             {{ $t('mobile.account_information.title_post') }}
                                          </p>
                                       </div>
                                    </div>
                                    <div class="payment-type__btn">
                                       <button class="button btn-orange"
                                          @click="openConfirmFromOriginalAccountModal(0)">
                                          {{ $t('buttons.register') }}
                                       </button>
                                    </div>
                                 </li>
                              </template>
                              <!-- End Mobile Balance Option -->
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- anhnt end logic moi -->
      <confirmation-modal :data="confirmationData" :onConfirm="onConfirmFromOriginalAccount" />
      <OtpModal :isShowOTP="isShowOTP" :periodTime="otpMetadata?.periodTime"
         :des="$t('mobile.data_packages.otp_desc')" modalBtnId="confirmOtpBtn" modalId="confirmOtpModal"
         :title="$t('mobile.data_packages.otp_title')" @closeOTP="isShowOTP = false" @resendOtp="sendOtp"
         @verifyOtp="onConfirmFromUmoney" />
      <button id="confirmOtpBtn2" data-bs-target="#confirmOtpModal2" data-bs-toggle="modal" style="display: none" />
      <div id="confirmOtpModal2" aria-hidden="true" aria-labelledby="confirm-otp" class="modal fade modal-custom"
         role="dialog" tabindex="-1">
         <div class="modal-dialog" role="document">
            <div class="modal-custom__content">
               <ValidationObserver v-slot="{ passes, reset }">
                  <div class="modal-custom__header">
                     <span class="modal-custom__action" data-bs-dismiss="modal" @click.prevent="reset"><i
                           class="icon-fonts icon-fonts--close"></i></span>
                  </div>
                  <div class="modal-custom__body">
                     <h3 class="modal-custom__title">{{ $t('mobile.data_packages.registration_confirmation') }}</h3>
                     <p class="modal-custom__des">{{ $t('mobile.data_packages.otp_message') }}</p>
                     <form @submit.prevent="passes(onConfirmFromUmoney)" @reset.prevent="reset">
                        <div class="modal-custom__form">
                           <Input v-model="otp" :hasResetIcon="true" :name="$t('mobile.data_packages.otp')"
                              :placeholder="$t('mobile.data_packages.enter_otp')" rules="required|max:6"
                              type="number" />
                           <div class="modal-custom__otp">
                              <span style="
                                    color: #979797;
                                    font-size: 12px;
                                    line-height: 20px;
                                    text-align: center;
                                    margin-right: 5px;
                                 ">{{ $t('mobile.data_packages.not_receive_otp') }}</span>
                              <a class="modal-custom__otp-link" href="javascript:void(0)" @click="sendOtp">
                                 {{ $t('mobile.data_packages.resend_otp') }}
                              </a>
                           </div>
                        </div>
                        <div class="modal-custom__btn">
                           <button class="button button--normal button--medium" data-bs-dismiss="modal" type="reset">
                              {{ $t('buttons.close') }}
                           </button>
                           <button class="button button--primary button--medium" type="submit">
                              {{ $t('buttons.confirm') }}
                           </button>
                        </div>
                     </form>
                  </div>
               </ValidationObserver>
            </div>
         </div>
      </div>
      <view-modal :data="view" />
   </div>
</template>
<script>
import $ from 'jquery'
import BaseComponent from '@/mixins/BaseComponent'
import LocalStorage from '@/ultils/local-storage'
import service from '../../services/MobileService'
import ConfirmationModal from '@/components/modal/ConfirmationModal'
import ViewModal from '@/components/modal/ViewModal'
import { ValidationObserver } from 'vee-validate'
import Input from '@/components/form/Input'
import OtpModal from '@/components/otp/OtpModal.vue'

export default {
   name: 'register-pack-flow',
   mixins: [BaseComponent],
   components: {
      ConfirmationModal,
      ViewModal,
      ValidationObserver,
      Input,
      OtpModal
   },
   props: {
      data: Object
   },
   data() {
      return {
         userInfo: '',
         confirmationData: {},
         otp: '',
         view: {
            name: '',
            url: ''
         },
         isErrUmoney: false,
         isPaymentBalance: false,
         isPaymentUmoney: false,
         isPaymentUpoint: false,
         uMoney: {},
         accountInfo: {},
         dataPackageDetail: {},
         subType: 0,
         payType: 0,
         otpMetadata: {},
         isShowOTP: false
      }
   },
   computed: {
      registerRoamingLater() {
         console.log(this.data.isRoamingLater)
         console.log(this.data.effectiveDate)
         return !this.data.isRoamingLater;
      }
   },
   created() {
      this.userInfo = JSON.parse(LocalStorage.getItem('user_info'))
   },
   methods: {
      openRegisterModals() {
         $('#registerPackBtn').trigger('click')
      },
      openConfirmFromOriginalAccountModal(payType) {
         console.log('openConfirmFromOriginalAccountModal payType ', this.data.longDescription)
         if (this.data.command) {
            this.data.code = this.data.command
            // this.data.shortDes = this.data.longDescription
         }
         this.payType = payType
         this.confirmationData = {
            content: this.$i18n
               .t('mobile.data_packages.confirm_registration')
               .replace('{0}', this.data.shortDes ? this.data.shortDes : this.data.code)
         }
      },
      onConfirmFromOriginalAccount() {
         this.showLoading()
         console.log('onConfirmFromOriginalAccount payType ', this.payType)
         console.log('onConfirmFromOriginalAccount command ', JSON.stringify(this.data.command))
         if (this.data.command) {
            let accountType = this.payType
            if (this.payType == 3) {
               accountType = 2
            }
            // kiem tra trang thai neu chua dang ky roaming thi dk
            if (LocalStorage.getItem('roamingStatus') !== 'true') {
               service
                  .registerRoaming()
                  .then((response) => {
                     if (response.errorCode === '0') {
                        // this.$store.dispatch('setNotification', {
                        //    content: response.userMsg ?? response.message,
                        //    icon: './images/ic-success.svg'
                        // })
                        // this.getRoaming()
                        service
               .registerPacketRoaming({
                  accountType: accountType,
                  command: this.data.command
               })
               .then((response) => {
                  console.log('onConfirmFromOriginalAccount registerPacketRoaming response ', response)
                  if (response.errorCode === '0') {
                     this.$store.dispatch('setNotification', {
                        content: response.message ?? response.userMsg,
                        icon: './images/ic-success.svg'
                     })
                  } else {
                     this.$store.dispatch('setNotification', {
                        content: response.message ?? response.userMsg
                     })
                  }
               })
               .finally(() => {
                  this.hideLoading()
               })
                     } else {
                        // this.$store.dispatch('setNotification', { content: response.userMsg ?? response.message })
                     }
                  })
                  .catch((ex) => {
                     console.log(ex)
                     // this.hideLoading()
                  })
                  .finally(() => {
                     // this.hideLoading()
                  })
            } else {
               service
               .registerPacketRoaming({
                  accountType: accountType,
                  command: this.data.command
               })
               .then((response) => {
                  console.log('onConfirmFromOriginalAccount registerPacketRoaming response ', response)
                  if (response.errorCode === '0') {
                     this.$store.dispatch('setNotification', {
                        content: response.message ?? response.userMsg,
                        icon: './images/ic-success.svg'
                     })
                  } else {
                     this.$store.dispatch('setNotification', {
                        content: response.message ?? response.userMsg
                     })
                  }
               })
               .finally(() => {
                  this.hideLoading()
               })
            }
            
         } else {
            let request = { actionType: 0, serviceCode: this.data.code }
            
            if (this.data.isRoamingLater) {
               if (this.payType == 3) {
               this.payType = 2
               request.payType = this.payType
            }
               service.buyRoamingLater({
                  accountType: 0,
                  command: this.data.code,
                  effectiveDate: this.data.effectiveDate,
                  otp: '0000'
               }).then((response) => {
                  console.log('onConfirmFromOriginalAccount buyRoamingLater response ', response)
                  if (response.errorCode === '0') {
                     this.$store.dispatch('setNotification', {
                        content: response.message ?? response.userMsg,
                        icon: './images/ic-success.svg'
                     })
                  } else {
                     this.$store.dispatch('setNotification', {
                        content: response.message ?? response.userMsg
                     })
                  }
               }).finally(() => {
                  this.hideLoading()
               })
            } else {
               if (this.payType == 3) {
               // this.payType = 2
               request.payType = this.payType
            }
               service
                  .doActionService(request)
                  .then((response) => {
                     console.log('onConfirmFromOriginalAccount doActionService response ', response)
                     this.$store.dispatch('setNotification', { content: response.message ?? response.userMsg })
                  })
                  .finally(() => {
                     this.hideLoading()
                  })
            }
         }
      },
      checkEwalletInfo() {
         // if roaming
         if (this.data.command) {
            this.openConfirmFromOriginalAccountModal(1)
         } else {
            this.showLoading()
            service
               .getEwalletInfo({ isdnEwallet: this.userInfo['isdn'] })
               .then((response) => {
                  if (response.errorCode == '0') {
                     if (response.wsResponse.responseCode === '00000') {
                        this.sendOtp(this.handleOpenOTPModal)
                     } else if (response.wsResponse.responseCode === '10114') {
                        this.$store.dispatch('setNotification', {
                           content: this.$i18n.t('errors.locked_account')
                        })
                     } else if (
                        response.wsResponse.responseCode === '10116' ||
                        response.wsResponse.responseCode === '10117'
                     ) {
                        this.setViewModal('', 'https://webview.unitel.com.la:9443/#/sign-up/startC')
                     } else {
                        this.$store.dispatch('setNotification', { content: this.$i18n.t('errors.system') })
                     }
                  } else {
                     this.$store.dispatch('setNotification', { content: response.message ?? response.userMsg })
                  }
               })
               .finally(() => {
                  this.hideLoading()
               })
         }
      },
      handleOpenOTPModal() {
         $('#confirmOtpBtn').trigger('click')
      },
      sendOtp(callback) {
         this.showLoading()
         this.isShowOTP = false
         if (this.data.isRoamingLater) {
            service
            .bccsGetOTPScratchCard()
            .then((response) => {
               if (response.errorCode === '0') {
                  this.otpMetadata = {
                     periodTime: 59
                  }
                  console.log('RegisterPackFlow sendOtp bccsGetOTPScratchCard ', this.otpMetadata.periodTime)
                  callback && callback()
                  this.isShowOTP = true
               } else {
                  this.$store.dispatch('setNotification', { content: response.wsResponse }) // debug
               }
            })
            .catch((ex) => {
               console.log(ex)
               this.hideLoading()
            })
            .finally(() => {
               this.hideLoading()
            })
         } else {
            service
            .getOtpWithoutPassword()
            .then((response) => {
               if (response.errorCode === '0') {
                  this.otpMetadata = {
                     periodTime: 59
                  }
                  console.log('RegisterPackFlow sendOtp getOtpWithoutPassword ', this.otpMetadata.periodTime)
                  callback && callback()
                  this.isShowOTP = true
               } else {
                  this.$store.dispatch('setNotification', { content: response.wsResponse }) // debug
               }
            })
            .catch((ex) => {
               console.log(ex)
               this.hideLoading()
            })
            .finally(() => {
               this.hideLoading()
            })
         }
      },
      onConfirmFromUmoney(otp) {
         this.showLoading()
         console.log('this.data.isRoamingLater', this.data.isRoamingLater)
         if (this.data.isRoamingLater) {
            service.buyRoamingLater({
               accountType: 1,
               command: this.data.code,
               effectiveDate: this.data.effectiveDate,
               otp: otp
            }).then((response) => {
               console.log('onConfirmFromUmoney buyRoamingLater response ', response)
               if (response.errorCode === '0') {
                  this.$store.dispatch('setNotification', {
                     content: response.message ?? response.userMsg,
                     icon: './images/ic-success.svg'
                  })
               } else {
                  this.$store.dispatch('setNotification', {
                     content: response.message ?? response.userMsg
                  })
               }
            }).finally(() => {
               this.hideLoading()
            })
         } else {
            service
               .doActionService({
                  actionType: 0,
                  payType: 1,
                  serviceCode: this.data.code,
                  channel: 'MyUnitel',
                  otp: otp
               })
               .then((response) => {
                  console.log('onConfirmFromUmoney doActionService response ', response)
                  if (response.errorCode === '0') {
                     this.$store.dispatch('setNotification', {
                        content: response.message ?? response.userMsg,
                        icon: './images/ic-success.svg'
                     })
                  } else {
                     this.$store.dispatch('setNotification', {
                        content: response.message ?? response.userMsg
                     })
                  }
               })
               .finally(() => {
                  this.hideLoading()
               })
         }
      },
      setViewModal(name, url) {
         this.view = { name, url }
      },
      convertNumber(val) {
         if (val) {
            let number = parseFloat(val.replaceAll(',', ''))
            return number
         }
         return 0
      },
      redirectRouter(url) {
         $('#registerPackBtn').trigger('click')
         this.$router.push(url)
      },
      openDeepLink(url) {
         window.open(url)
      }
   },
   watch: {
      async data() {
         this.isErrUmoney = false
         this.isPaymentBalance = false
         this.isPaymentUmoney = false
         this.isPaymentUpoint = false
         this.showLoading()
         let subType = 0
         let dataPackageDetail = {}
         let uMoney = {}
         let accountInfo = {}
         try {
            const userApi = service.getUserInfo().then((response) => {
               LocalStorage.setItem('subType', response.wsResponse.subType)
               subType = response.wsResponse.subType
               this.subType = subType
            })

            const dataPackageApi = service
               .getDataPackageDetailByCode({
                  packageCode: this.data.code
               })
               .then((response) => {
                  if (response.errorCode === '0') {
                     dataPackageDetail = response.wsResponse ?? {}
                     this.dataPackageDetail = dataPackageDetail
                     if (!response.wsResponse) {
                        service.getDataPromotionDetail({ packageCode: this.data.code }).then((response) => {
                           dataPackageDetail = response.wsResponse ?? {}
                           this.dataPackageDetail = response.wsResponse ?? {}
                        })
                     }
                  }
               })

            let uMoneyApi
            try {
               uMoneyApi = service.getUMoney().then((response) => {
                  if (response.errorCode === '0') {
                     uMoney = response.wsResponse ?? {}
                     this.uMoney = uMoney
                  } else {
                     this.isErrUmoney = true
                  }
               })
            } catch (error) {
               this.isErrUmoney = true
            }
            // == 1 trả trước, ==2 trả sau
            // let userDetail = JSON.parse(LocalStorage.getItem('user_info')) ?? {}
            // let isdn = userDetail.isdn
            // if(this.subType == 1){

            await Promise.allSettled([userApi, dataPackageApi, uMoneyApi])
            let wsGetSubAccountInfoData = JSON.parse(LocalStorage.getItem('wsGetSubAccountInfo')) ?? {}
            if (Object.keys(wsGetSubAccountInfoData).length == 0) {
               await service.getSubAccountInfo({ subType: parseInt(this.subType) }).then((response) => {
                  let data = response.wsResponse
                  accountInfo = data
                     ? {
                        prePost: data.prePost ?? 0,
                        debPost: data.debPost ?? 0,
                        mainAcc: data.mainAcc ?? 0,
                        proAcc: data.proAcc ?? 0,
                        uPoint: data.uPoint ?? 0,
                        dataPkgName: data.name,
                        dataVolume: data.dataVolume
                     }
                     : {}

                  this.accountInfo = accountInfo
               })
            } else {
               let data = wsGetSubAccountInfoData.data.wsResponse
               accountInfo = data
                  ? {
                     prePost: data.prePost ?? 0,
                     debPost: data.debPost ?? 0,
                     mainAcc: data.mainAcc ?? 0,
                     proAcc: data.proAcc ?? 0,
                     dataPkgName: data.name,
                     uPoint: data.uPoint ?? 0,
                     dataVolume: data.dataVolume
                  }
                  : {}

               this.accountInfo = accountInfo
            }
            // }
            // với trả sau luôn cho thang toán bằng balance
            // debugger; // eslint-disable-line no-debugger
            if (this.subType == 2) {
               this.isPaymentBalance = true
               if (uMoney && Object.keys(uMoney).length != 0) {
                  let eMoneyValue = uMoney.eMoneyValue ?? 0
                  let price = dataPackageDetail.price ?? 0
                  if (this.convertNumber(eMoneyValue) >= parseFloat(price)) {
                     this.isPaymentUmoney = true
                  }
               }
               if (accountInfo && Object.keys(accountInfo).length != 0) {
                  let price = dataPackageDetail.price ?? 0
                  if (accountInfo.uPoint >= parseFloat(price)) {
                     this.isPaymentUpoint = true
                     console.log('isPaymentUpoint 1')
                  }
               }
            } else if (this.subType == 1) {
               if (uMoney && Object.keys(uMoney).length != 0) {
                  let eMoneyValue = uMoney.eMoneyValue ?? 0
                  let price = dataPackageDetail.price ?? 0
                  if (this.convertNumber(eMoneyValue) >= parseFloat(price)) {
                     this.isPaymentUmoney = true
                  }
               }
               if (accountInfo && Object.keys(accountInfo).length != 0) {
                  // let eMoneyValue = uMoney.eMoneyValue ?? 0
                  let mainAcc = accountInfo.mainAcc ?? 0
                  let price = dataPackageDetail.price ?? 0
                  if (mainAcc >= parseFloat(price)) {
                     this.isPaymentBalance = true
                  }
                  if (accountInfo.uPoint >= parseFloat(price)) {
                     this.isPaymentUpoint = true
                     console.log('isPaymentUpoint 2')
                  }
               }
            }
         } catch (error) {
            this.hideLoading()
         }
         // console.log("this.subType",this.subType)
         // console.log("this.uMoney",this.uMoney)
         // console.log("this.dataPackageDetail",this.dataPackageDetail)
         // console.log("this.accountInfo",this.accountInfo)
         this.hideLoading()
         $('#registerPackBtn').trigger('click')
      }
   }
}
</script>

<style lang="scss" scoped>
.btn-orange {
   margin: 0;
   border: none;
   background: var(--bs-primary);
   border-radius: 100px;
   min-width: 75px;
   height: 33px;

   font-size: 11px;
   font-weight: 600;
}

.btn-white {
   margin: 0;
   border: none;
   border-radius: 100px;
   min-width: 75px;
   height: 33px;

   font-size: 11px;
   font-weight: 600;
   background: var(--bs-white);
   color: black;
   border: 1px solid var(--bs-primary);
}

.modal-custom__action {
   background-color: var(--bs-primary);
   border-radius: 50%;
   color: white;
   display: flex;
   justify-content: center;
   align-items: center;
   padding: 3px;
}

.payment-money {
   font-weight: 600;
   font-size: 13;
   color: var(--bs-primary);
}

.payment-type__item {
   border: 1px solid #ffe2d1;
}
</style>
